import Record from './record';

export default Record;
